import React from 'react'
const SvgArrow3 = props => (
  <svg viewBox='0 0 24.13 16.97' {...props}>
    <g data-name='\u56FE\u5C42 2'>
      <path
        fill='#fff'
        d='M22.72 7.07L15.65 0l-1.42 1.41 6.08 6.08H0v1.99h20.31l-6.08 6.08 1.42 1.41 8.48-8.49-1.41-1.41z'
        data-name='\u56FE\u5C42 1'
      />
    </g>
  </svg>
)
export default SvgArrow3
